import React from 'react';
import LiveRegion from '../../../../components/atoms/LiveRegion/LiveRegion';
import { FormUtils, useFormContext } from '../../../../components/molecules/Form';
import { InteractionStatus } from '../../../../types/InteractionStatus';
import FormsElementContainer, {
  FormsElementContainerModifier,
} from '../../../../components/molecules/Form/components/FormsElementContainer/FormsElementContainer';
import Btn from '../../../../components/molecules/Btn';
import { useSonTranslation } from '../../../../translation/useSonTranslation';

export default function AnnouncementConfirmFormTemplate() {
  const { inputs, getStatus, status, submitActionEnabled } = useFormContext();
  const { t } = useSonTranslation('Announcement');

  const statusMessages = {
    [InteractionStatus.SUCCESS]: FormUtils.createStatusMessage(t(`confirmForm.status.success`)),
    [InteractionStatus.SENDING]: FormUtils.createStatusMessage(t(`confirmForm.status.sending`)),
    [InteractionStatus.FAIL]: FormUtils.createStatusMessage(t(`confirmForm.status.fail`)),
  };

  return (
    <>
      <input type="hidden" name={inputs.announcementId.name} value={inputs.announcementId.value} />
      <FormsElementContainer modifier={FormsElementContainerModifier.BUTTON_GROUP_RIGHT}>
        <Btn
          cssClass="btn--single-action btn--single-action-yes"
          text={t('confirmForm.submit')}
          type={submitActionEnabled() ? 'submit' : 'button'}
          ariaDisabled={!submitActionEnabled()}
        />
      </FormsElementContainer>
      <LiveRegion invisible={false} htmlTag="div">
        {getStatus(statusMessages, status)}
      </LiveRegion>
    </>
  );
}
